<template>
  <div class="w-full border-t-8 border-orange-400">
    <div class="w-full p-10 mx-auto md:w-3/4">
      <p class="text-center">&copy; {{ year }} Bobbe Harris. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>
